import { render, staticRenderFns } from "./ApexChartPie.vue?vue&type=template&id=566ed7f5&"
import script from "./ApexChartPie.vue?vue&type=script&lang=js&"
export * from "./ApexChartPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports